import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex)
const state = {
  saveTitle: '',
  saveContent: '',
  saveTitleList: [],
  saveContentList:[],
  checkArticle:'',
  checkList:'',
},
  // 相当于Vuex中的计算属性
  getters = {

  },
  mutations = {
    saveTitle(state, ploady) {
      return state.saveTitle = ploady;
    },
    saveTitleList(state, ploady) {
      return state.saveTitleList = ploady;
    },
    saveContent(state, ploady) {
      return state.saveContent = ploady;
    },
    saveContentList(state, ploady) {
      return state.saveContentList = ploady;
    },
    saveCheckArticle(state, ploady) {
      return state.checkArticle = ploady;
    },
    saveCheckList(state, ploady) {
      return state.checkList = ploady;
    },
  },
  actions = {

  }

export default new Vuex.Store({
  actions,
  mutations,
  state,
})